/**
 * <product-express-checkout>
 * Wraps the accelerated/buy-now checkout buttons (product-buy-now-test.liquid).
 *
 * - Variant switching: update(variantId) writes the selected variant id into
 *   this instance's hidden checkout form input so express checkout buys the
 *   right variant.
 * - Public API:
 *     update(variantId)
 */

class ProductExpressCheckout extends HTMLElement {
  connectedCallback() {
    // Only the id is needed here, so read variantId (not the full variant object)
    // off the switcher's broadcast.
    this._variantChangedHandler = (event) => {
      const variantId = event?.detail?.variantId;
      if (variantId != null) this.update(variantId);
    };
    window.addEventListener("enroute:variant-changed", this._variantChangedHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("enroute:variant-changed", this._variantChangedHandler);
  }

  /**
   * Sync this express form to the selected variant. Driven by the variant
   * switcher's enroute:variant-changed event; also callable directly.
   *
   * @param {string|number} variantId - the selected variant id
   */
  update(variantId) {
    const inputs = this.querySelectorAll('input[name="id"].hvg-checkout-product-variant-id');
    inputs.forEach((input) => {
      input.value = variantId;
    });
  }
}

if (!window.customElements.get("product-express-checkout")) {
  window.customElements.define("product-express-checkout", ProductExpressCheckout);
}
